export default "<br>\r\n\r\n<div class=\"alert alert-danger\">\r\n  <strong>Debe logearse para acceder a la URL</strong>\r\n</div>\r\n"